<template>
  <div class="container mb-0 pt-0 mt-60">
        <div class="section-content">
            <ProgressBar :currentStep="currentStep" :totalSteps="7" />
            <br>
            <h3 style="text-align: center;">Stpe: {{currentStep}}</h3>
            <br>
            <div v-for="step in steps" :key="step.id">
              <FormStep 
                v-if="currentStep === step.id"
                :step="step.id"
                :stepName="step.name"
                :fields="step.fields"  
                :formData="formData"
                @advance="currentStep++"
                @retreat="currentStep--"
              />
            </div>
            <div v-if="currentStep === 9">
                <!-- Show form data or a thank you message -->
                    <div class="centered-content">
                      <h1>Congratulations!</h1>
                       <p>You have successfully completed all the steps.</p>
                    </div>
                    <div class="button-container">
                      <button @click="createnewfederation()" class="submit-button">Create New Federation</button>
                    </div>
                <!-- <pre>{{ formData }}</pre> -->
            </div>


        </div>
  </div>
</template>
<script>
import { reactive, onMounted } from 'vue';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import FormStep from "./FormStep.vue";
import ProgressBar from './ProgressBar.vue';
export default{
components: {
    FormStep,
    ProgressBar
  },
  mounted(){
   
  },
  computed:{
    url(){
      return this.$store.state.url;
    }
  },
  methods:{
   createnewfederation(){
     axios.post(this.url+'createnewfederation',{
         data:this.formData,
     }).then(response=>{

        toast.warning("New fedeation has created successfully", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });
         
     })
   }

  },
  data() {
    return {
      currentStep: 1,
      formData: {},
      steps: [

      { 
        id: 1, 
        name: 'Federation General Information',
        fields: [
          { name: 'FederationName', label: 'Federation Name', inputType: 'text', required: true },
          { name: 'District', label: 'District',inputType: 'select',options:[], required: true },
          { name: 'Upazila', label: 'Upazila',inputType: 'select', 
          options: [], required: true },
          { name: 'Village', label: 'Village', inputType: 'text', required: true },
          { name: 'PostOffice', label: 'Post Office', inputType: 'text', required: true },
          { name: 'FormationYear', label: 'Formation Year',inputType: 'text', required: true },
          { name: 'FemaleHeaded', label: 'Female Headed',inputType: 'text', required: true },
          { name: 'FederationChairmanName', label: 'Federation Chairman Name ',inputType: 'text', required: true },
          { name: 'ChairmanMobileNumber', label: 'Chairman Mobile number',inputType: 'text', required: true },
          { name: 'grade_and_present', label: 'Grade And Present',inputType: 'text', required: true },

        ] 

      },      
      { 
        id: 2, 
        name: 'Federation Registration Information',
        fields: [
          { name: 'RegistrationNumber', label: 'Registration Number',inputType: 'text', required: true },
          { name: 'RegistrationReceivedfrom', label: 'Registration Received from (DSS/DYD /DC/DWA)*',inputType: 'text', required: true },
          { name: 'If_Dont_is_applied_for_registration_YesNo',inputType: 'text', label: 'If Do not is applied for registration Yes No', required: true },
          { name: 'If_applied_name_of_the_organization_DSSDYD_DCDWA',inputType: 'text', label: 'If applied name of the organization DSSDYD DCDWA', required: true },
          { name: 'Date_of_application_deposited', label: 'Date of application deposited',inputType: 'text', required: true },
          { name: 'Present_status', label: 'Present status',inputType: 'text', required: true },

        ] 

      },      
      { 
        id: 3, 
        name: 'Federation Group Information',
        fields: [
          { name: 'MaleGroup', label: 'Male Group',inputType: 'text', required: true },
          { name: 'FemaleGroup', label: 'Female Group',inputType: 'text', required: true },
          { name: 'Total', label: 'Total',inputType: 'text', required: true },

        ] 

      },      
      { 
        id: 4, 
        name: 'Federation General Member',
        fields: [
          { name: 'Male', label: 'Boy',inputType: 'text', required: true },
          { name: 'Female', label: 'Gril',inputType: 'text', required: true },
          { name: 'FederationTotal', label: 'Total Member',inputType: 'text', required: true },
          { name: 'PWD_Member', label: 'PWD Member',inputType: 'text', required: true },
          { name: 'Indigenous_People', label: 'Indigenous People',inputType: 'text', required: true },
          { name: 'ExcludedMembers', label: 'Excluded Members',inputType: 'text', required: true },

        ] 

      },      
      { 
        id: 5, 
        name: 'General Committee Member',
        fields: [
          { name: 'CommitteeMemberMale', label: 'Committee Member Male',inputType: 'text', required: true },
          { name: 'CommitteeMemberFemale', label: 'Committee Member Female',inputType: 'text', required: true },
          { name: 'CommitteeMemberTotal', label: 'Committee Member Total',inputType: 'text', required: true },

        ] 

      },

      { 
        id: 6, 
        name: 'Executive Committee Member',
        fields: [
          { name: 'ExecutiveCommitteeMemberMale', label: 'Executive Committee Member Male',inputType: 'text', required: true },
          { name: 'ExecutiveCommitteeMemberFemale', label: 'Executive Committee Member Female',inputType: 'text', required: true },
          { name: 'ExecutiveCommitteeMemberTotal', label: 'Executive Committee Member Total',inputType: 'text', required: true },

        ] 

      },

        { 
        id: 7, 
        name: 'Information on Social Forestry Program',
        fields: [
          { name: 'number_age_above_three', label: 'number age above trees',inputType: 'text', required: true },
          { name: 'number_of_three_reporting_period', label: 'number of trees reporting period',inputType: 'text', required: true },
          { name: 'amoun_recive_by_selling_trees', label: 'Amount Recive By selling Trees',inputType: 'text', required: true },
          { name: 'federation_bank_account', label: 'Federation Bank Account',inputType: 'text', required: true },

        ] 

      },


       { 
        id: 8, 
        name: 'Federation members are in SSN and MF Program',
        fields: [
          { name: 'social_safety_net_program', label: 'Social Safety Net Program ',inputType: 'text', required: true },
          { name: 'micro_finance_program', label: 'Micro Finance Program',inputType: 'text', required: true },
        
        ] 

      },




    ]

    }
  },

}  
</script>
<style>
  .centered-content {
    text-align: center;
    padding: 60px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
}

h1 {
    color: #2c3e50;
    margin-bottom: 10px;
}

p {
    color: #7f8c8d;
}
.button-container {
    text-align: center;
    width: 100%;
    position: absolute;
    bottom: 10%; /* Adjust to your liking */
    left: 0;
    top: 250px;
}

.submit-button {
    padding: 10px 20px;
    font-size: 16px;
    background-color: #3498db;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;

}
.submit-button:hover {
    background-color: #2980b9;
}
</style>


